import { render, staticRenderFns } from "./t-orm-simple-data-item.vue?vue&type=template&id=4a91ee52&scoped=true&lang=pug&"
import script from "./t-orm-simple-data-item.vue?vue&type=script&lang=js&"
export * from "./t-orm-simple-data-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a91ee52",
  null
  
)

export default component.exports